import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { BrandIconUtil } from '../../../utils/brand.util';
import { APP_PROPS } from '../../../cai-common.module';
import { ApplicationProperties } from '../../../core/_base/layout/models/app-properties.model';

@Component({
  selector: 'kt-registration-video',
  templateUrl: './registration-video.component.html',
  styleUrls: ['./registration-video.component.scss'],
  standalone: false,
})
export class RegistrationVideoComponent implements OnInit {
  isCargoAiDomain = BrandIconUtil.isCargoAiDomain();
  isVideoClosed = false;
  videoUrl = '/static/videos/cargoai-product-intro.mp4';

  constructor(
    @Inject(APP_PROPS)
    private readonly appProperties: ApplicationProperties,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (this.appProperties.name === 'cargowallet') {
      this.videoUrl = '/static/videos/cargoai-wallet-intro.mp4';
    }
    this.onResize();
    this.cdr.detectChanges();
  }

  closeVideo() {
    this.isVideoClosed = true;
    this.cdr.detectChanges();
  }

  onResize() {
    this.isVideoClosed = window.innerWidth < 1250;
    this.cdr.detectChanges();
  }
}
